import styled from 'styled-components';
import { Link } from 'gatsby';

export const Container = styled.div`
  display: flex;
  padding-bottom: 64px;
  flex-direction: column;
  align-items: center;
`;

export const ContentBlock = styled.div`
  display: flex;
  max-width: 1440px;
  margin: 0 auto;
  padding: 64px 0px;
  justify-content: center;
  align-items: center;
  gap: 32px;
  padding: 0 32px;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    padding: 0 16px;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  max-width: 1120px;
  align-items: center;
  gap: 64px;
  flex: 1 0 0;
  flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    flex-direction: column-reverse;
    gap: 0;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  max-width: 1120px;
  padding: 32px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  flex: 1 0 0;

  h2 {
    font-size: 32px;
    font-weight: 700;
    margin: 0;
    color: ${({ theme }) => theme.global.colors.black};
  }

  p {
    font-size: 20px;
    line-height: 32px;
    margin: 0;
    color: ${({ theme }) => theme.global.colors.black};
  }

  ul {
    list-style: disc;
    padding-left: 1.5rem;
    margin-bottom: 0;
    color: ${({ theme }) => theme.global.colors.black};
  }

  li {
    font-size: 20px;
    line-height: 32px;
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.global.colors.black};
  }
`;

export const Image = styled.img`
  flex: 1;
  max-width: 400px;
  width: 100%;
  height: auto;
  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    max-width: 200px;
  }
`;

export const Button = styled(Link)`
  margin-top: 12px;
  background-color: ${({ theme }) => theme.global.colors.primary};
  color: white;
  padding: 14px;
  font-weight: bold;
  font-size: 1rem;
  border: none;
  border-radius: 32px;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background-color: #00b453;
  }
  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    display: none;
  }
`;
